import React from "react";
import Header from "@/components/en/Header";
import Menu from "@/components/en/Menu";
import Footer from "@/components/en/Footer";
import FloatingButton from "@/components/en/FloatingButton";
import ScrollToTopFab from "@/components/en/ScrollToTopFab";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import SInstru from "@/public/static/images/opacity_instru.png";
import SPorcess from "@/public/static/images/opacity_process.png";
import SNews from "@/public/static/images/opacity_news.png";

import ISO1 from "@/public/static/images/iso9001.png";
import ISO2 from "@/public/static/images/iatf16949.png";

import Map from "@/public/static/images/zeniya_map.png";

import Modal from "@mui/material/Modal";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  height: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0,
};

const breadcrumbs = [
  <Link key="1" href="/en/">
    Home
  </Link>,
  <Typography key="2">About Us</Typography>,
];

function Aboutus() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [image, setImage] = React.useState<any>(null);
  const [aboutName, setaboutName] = React.useState<string | null>(null);
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  About Us
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="box-about_text">
                <h3>Origin of Company Name</h3>
                <span className="d-block mb-3">
                  When the late Mr. Isaburo Takeyasu, the founder of the
                  companies in the Zeniya Alminum Group, started his company, he
                  named it ZENIYA, after Mr. Zeniya Gohei, one of the greatest
                  merchants in the Edo Period and whose activities extended from
                  Kuril Island and Kamchatka to the Island of Tasmania,
                  Australia. After repeatedly reading as a boy the success
                  stories of Mr. Zeniya Gohei with pleasure, our founder came to
                  deeply sympathize with his way of life.
                </span>
                <span className="d-block">
                  Mr. Takeyasu selected a design of an old coin, the
                  Kanei-Tsuho, for his company flag, as it reminded him of Mr.
                  Zeniya Gohei’s flag emblem. The Kanei-Tsuho was the principal
                  coin in the Edo Period, and it is still loved and well known
                  in Japan. We hope that our company will be loved in the same
                  way and therefore choose this coin for the flag’s design.
                </span>
              </div>
            </div>
            <div className="col-12 py-3">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Our Story</h5>
              </div>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Company Name
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          ZENIYA (THAILAND) CO.,LTD.
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Representative Person
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Yoshihiro Hirota MD
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Business Description
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Production and sales of Metal forming and surface
                          treatment products
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Product Line
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Stamping, machining and anodizing parts for
                          automotive, motorcycle, electronics and outdoor
                          industry. Large metal fabricadtion work for plant and
                          infrastructure. Maritime buoy.
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Head Office
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Amata City Chonburi Industrial Estate Phase 8 <br />
                          700/750 Moo 1, Phan Thong, Chonburi 20160 Thailand
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          TEL. 03-818-5512-5
                        </Typography>
                        <Link href={"#accessmap"} scroll={false}>
                          <LocationOnIcon
                            sx={{ fontSize: "16px", mb: 0.5, color: "#0179cc" }}
                          />
                          Access Map
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Person in Charge
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Mr.Fujiwara (JP/EN)
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          Email:
                          <a
                            className="t-blue mx-1"
                            href="mailto:info@zeniya-thai.com"
                          >
                            info@zeniya-thai.com
                          </a>
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          Mobile: 08-1803-4856
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Website
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.zeniyaalumi.co.jp"
                        >
                          https://www.zeniyaalumi.co.jp
                        </a>
                        <br />
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.zeniya-thai.com"
                        >
                          https://www.zeniya-thai.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Establish Date
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          May 2011
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Parent Company
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          Zeniya Aluminum Engineering, Ltd.
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Employee
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <Typography variant="body1" gutterBottom>
                          210 (October 2024)
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <div className="list-about">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <Typography variant="h6" gutterBottom>
                          Certificate
                        </Typography>
                      </div>
                      <div className="col-12 col-md-9">
                        <div className="row">
                          <div className="col-12 col-md-3 text-center">
                            <Typography variant="body1" gutterBottom>
                              ISO9001:2015
                              <Link
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setOpen(true);
                                  setImage(ISO1);
                                  setaboutName("ISO9001:2015");
                                }}
                              >
                                <Image
                                  loading="lazy"
                                  src={ISO1}
                                  alt="Process & Usage"
                                  className="card-img my-2"
                                  width={100}
                                />
                              </Link>
                            </Typography>
                          </div>
                          <div className="col-12 col-md-3 text-center">
                            <Typography variant="body1" gutterBottom>
                              IATF16949:2016
                              <Link
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setOpen(true);
                                  setImage(ISO2);
                                  setaboutName("IATF16949:2016");
                                }}
                              >
                                <Image
                                  loading="lazy"
                                  src={ISO2}
                                  alt="Process & Usage"
                                  className="card-img my-2"
                                  width={100}
                                />
                              </Link>
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-3" id="accessmap">
                  <div className="list-about list-last">
                    <div className="row">
                      <div className="col-12 my-3">
                        <Typography variant="h6" gutterBottom>
                          Access Map
                        </Typography>
                      </div>
                      <div className="col-12">
                        <Image
                          loading="lazy"
                          src={Map}
                          alt="Process & Usage"
                          className="card-img mb-3"
                          sizes="100vw"
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                        />
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3880.4900685020875!2d101.07291382478002!3d13.44386047776122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d30d15cf23663%3A0xc23238063d7d32c7!2sZeniya%20(Thailand)%20Co.%2CLtd.!5e0!3m2!1sen!2sth!4v1677284770579!5m2!1sen!2sth"
                          width="100%"
                          height="450"
                          style={{ border: 0 }}
                          loading="lazy"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-inner">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            className="close-btn"
          >
            <CloseIcon />
          </IconButton>
          <Image
            loading="lazy"
            src={image}
            alt="Certificate"
            className="card-img"
            sizes="100vw"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
          <Typography
            id="modal-modal-title"
            className="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {aboutName}
          </Typography>
        </Box>
      </Modal>

      <section className="sub-contact mt-5">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/en/processusage">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SPorcess}
                  alt="Process & Usage"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">Process & Usage</h1>
                </div>
              </div>
            </Link>
            <Link href="/en/instrument">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SInstru}
                  alt="Instrument Overview"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">Instrument Overview</h1>
                </div>
              </div>
            </Link>
            <Link href="/en/news">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SNews}
                  alt="News"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">News</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export default Aboutus;
